App.factory('Appointment', restmod => {
    return restmod.model('/appointments')
})
